import React, { createContext, useEffect, useState } from "react"
import {fetchCSV, parse as csvparse} from "../util/csvparseutil"

const CalendarEventContext = createContext()

// const gid0="gid=0&"           //Sheet1
const gid1="gid=1550840276&"  //ForumData
const url = `https://docs.google.com/spreadsheets/d/e/2PACX-1vQGq3o-UwP1FfFjgZHMB39FfYHqEqUgincsok28V2TpMTcfSr7XNUkwXQvQTds2wWD4npazyZAZjQdC/pub?${gid1}output=csv`;

function CalendarEventProvider(props) {

  const [events, setEvents] = useState([""])
  const [currentDefaultMonth, setcurrentDefaultMonth] = useState([1000,1])

  useEffect(() => {
    (async()=>{
      let csvtext = await fetchCSV(url)
      let {events, ingamemonth} = csvparse(csvtext)

      setEvents(events)
      setcurrentDefaultMonth(ingamemonth)
    })()
  }, [])


  return (
    <CalendarEventContext.Provider value={{ events, currentDefaultMonth }}>
      {props.children}
    </CalendarEventContext.Provider>
  )
}

export { CalendarEventProvider, CalendarEventContext }



